import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import ReactPlayer from 'react-player';

function convertToEmbedLink(googleDriveLink, autoplay = false) {
  const fileIdMatch = googleDriveLink.match(/\/file\/d\/(.*?)\//);

  if (fileIdMatch && fileIdMatch[1]) {
    const fileId = fileIdMatch[1];
    let embedLink = `https://drive.google.com/file/d/${fileId}/preview`;
    if (autoplay) {
      embedLink += '?autoplay=1'; // Attempt to autoplay the video
    }
    return embedLink;
  } else {
    return googleDriveLink;
  }
}

function isYouTubePlaylistLink(link) {
  return link.includes('youtube.com/playlist') || link.includes('youtu.be/playlist');
}

function convertYouTubePlaylistToEmbed(playlistLink, autoplay = false) {
  // Extract playlist ID from various YouTube playlist URL formats
  const playlistIdMatch = playlistLink.match(/[?&]list=([^&]+)/);

  if (playlistIdMatch && playlistIdMatch[1]) {
    const playlistId = playlistIdMatch[1];
    let embedLink = `https://www.youtube.com/embed/videoseries?list=${playlistId}`;

    if (autoplay) {
      embedLink += '&autoplay=1';
    }

    return embedLink;
  }

  return playlistLink;
}

const VideoPlayer = ({ videoLinks = [], height = 380, autoplay = true }) => {
  const [activeVideoTab, setActiveVideoTab] = useState(null);

  useEffect(() => {
    setActiveVideoTab(videoLinks[0]);
  }, [videoLinks]);

  const isGoogleDriveLink = link => {
    return link.includes('drive.google.com');
  };

  const isYouTubePlaylist = link => {
    return isYouTubePlaylistLink(link);
  };

  return (
    <>
      {videoLinks.length > 1 &&
        videoLinks.map((videoLink, index) => (
          <Button
            onClick={() => setActiveVideoTab(videoLink)}
            key={videoLink}
            size="sm"
            className="mx-1"
            variant={activeVideoTab === videoLink ? 'primary' : 'secondary'}
          >
            Video {index + 1}
          </Button>
        ))}

      {activeVideoTab &&
        (isGoogleDriveLink(activeVideoTab) ? (
          <iframe
            src={convertToEmbedLink(activeVideoTab, autoplay)}
            width="100%"
            height={height}
            frameBorder="0"
            allow="autoplay"
            style={{ margin: '0 auto', borderRadius: '8px' }}
          ></iframe>
        ) : isYouTubePlaylist(activeVideoTab) ? (
          <iframe
            src={convertYouTubePlaylistToEmbed(activeVideoTab, autoplay)}
            width="100%"
            height={height}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ margin: '0 auto', borderRadius: '8px' }}
          ></iframe>
        ) : (
          <ReactPlayer
            playing={autoplay}
            url={activeVideoTab}
            controls
            height={height}
            width="100%"
            style={{ margin: '0 auto' }}
          />
        ))}
    </>
  );
};

export default VideoPlayer;
